import { parseDate } from "web_myplann/Shared/Utils/parseDate";

export const sortByDate = <T>(
	items: T[],
	getDate: (item: T) => string | null | undefined,
	direction: "asc" | "desc" = "desc",
): T[] =>
	[...items].sort((a, b) => {
		const timeA = parseDate(getDate(a))?.getTime() ?? 0;
		const timeB = parseDate(getDate(b))?.getTime() ?? 0;
		return direction === "asc" ? timeA - timeB : timeB - timeA;
	});
